<div class="trip-detail-popup-right">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
</div>
<form [formGroup]="loadForm" class="admin-forms">
  <div class="accordion-class">
    <h5 *ngIf="data.type === 'New'">Add Load</h5>
    <h5 *ngIf="data.type === 'Edit'">Edit Load</h5>
    <mat-divider></mat-divider>
  </div>
  <!-- <div class="input-fileds-container">
    <div class="group">
      <div class="row">
        <div class="col-md-6"></div>
      </div>
    </div>
    <div class="driver-truck-load">
      <mat-form-field appearance="fill">
        <input
          type="text"
          matInput
          placeholder="Load Category"
          formControlName="loadCategory"
          value="{{ Commercial || NonCommercial }}"
          readonly
        />
        <mat-error
          *ngIf="
            loadForm.value.loadCategory.touched &&
            loadForm.value.loadCategory.errors.required
          "
        >
          Load Category is Required</mat-error
        >
      </mat-form-field>
    </div>
    <div class="w-100 pull-left mt-3">
      <mat-form-field class="example-chip-list" appearance="fill">
        <mat-chip-list #chipList aria-label="loadType selection">
          <mat-chip *ngFor="let item of material" (removed)="remove(item)">
            {{ item }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <input
            placeholder="New Load Type..."
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)"
          />
        </mat-chip-list>
        <mat-error *ngIf="loadTypeValidation"> Load Type is Required</mat-error>
      </mat-form-field>
    </div>
  </div> -->

  <div class="load-section-container">
    <h3 class="section-heading">
      {{ loadForm.get('loadCategory')?.value || 'Select Load Category' }}
    </h3>
    <div class="add-material-section">
      <div class="material-inputs">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Material Name</mat-label>
          <input
            matInput
            placeholder="Enter Material Name"
            [(ngModel)]="newMaterial.name"
            [ngModelOptions]="{ standalone: true }"
            name="materialName"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>HSN Code</mat-label>
          <mat-select
            [(ngModel)]="newMaterial.hsn_code"
            [ngModelOptions]="{ standalone: true }"
            name="hsnCode"
            placeholder="Select HSN Code"
          >
            <mat-option *ngFor="let item of hsnCodeList" [value]="item.hsn_code">
              {{ item.hsn_code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <button
        mat-raised-button
        color="primary"
        class="add-btn button"
        (click)="addMaterial()"
      >
        Add Material
      </button>
    </div>

    <!-- List of Added Materials -->
    <div class="material-list">
      <mat-card
        class="material-card"
        *ngFor="let item of material; let i = index"
      >
        <div class="material-info">
          <strong>{{ item.name }}</strong>
          <p>HSN: {{ item.hsn_code }}</p>
        </div>
        <button class="remove-btn">
          <img
            class="del"
            matTooltip="Remove Material"
            matTooltipPosition="above"
            src="../../../assets/img/delete-black.svg"
            (click)="remove(item)"
          />
        </button>
      </mat-card>
    </div>

    <ng-template #noMaterial>
      <p class="no-data">No materials added yet.</p>
    </ng-template>

  </div>
  <button
    *ngIf="data.type === 'New'"
    type="button"
    class="button buttonBlue"
    (click)="AddLoadDetails()"
  >
    Submit
  </button>
  <button
    *ngIf="data.type === 'Edit'"
    type="button"
    class="button buttonBlue"
    (click)="EditLoadDetails()"
  >
    Submit
  </button>
</form>
